import loadable from '@loadable/component';

const LazyLowResultsBanner = loadable(() => import('./LowResults'), {
    resolveComponent: (components: { LowResults: React.ReactElement }) =>
        components.LowResults,
});

const LazyNoResultsBanner = loadable(() => import('./NoResults'), {
    resolveComponent: (components: { NoResults: React.ReactElement }) =>
        components.NoResults,
});

export { LazyLowResultsBanner as LowResults };
export { LazyNoResultsBanner as NoResults };
